import { CategoryConfig } from '@/types/category';
import {
  meditationConfig,
  anxietyConfig,
  massageConfig,
  motivationConfig,
  memoryConfig,
  sleepConfig,
  beStillConfig,
  selfLoveConfig,
  fitnessConfig,
  lifeCelebrationsConfig
} from './standardCategories';
import { explicitMeditationConfig } from './explicitMeditation';
import { newsMeditationConfig } from './newsMeditation';
import { 
  sexualWellnessWomenConfig,
  couplesConnectionConfig,
  relationshipDecisionsConfig,
  addictionRecoveryMenConfig
} from './micheleTherapeuticCategories';
import { yogaMeditationConfig } from './yogaCategories';

export const categoryConfigs: Record<string, CategoryConfig> = {
  meditation: meditationConfig,
  anxiety: anxietyConfig,
  massage: massageConfig,
  motivation: motivationConfig,
  memory: memoryConfig,
  sleep: sleepConfig,
  be_still: beStillConfig,
  self_love: selfLoveConfig,
  fitness: fitnessConfig,
  life_celebrations: lifeCelebrationsConfig,
  'zen-af': explicitMeditationConfig,
  'news-meditation': newsMeditationConfig,
  'sexual-wellness-women': sexualWellnessWomenConfig,
  'couples-connection': couplesConnectionConfig,
  'relationship-decisions': relationshipDecisionsConfig,
  'addiction-recovery-men': addictionRecoveryMenConfig,
  'yoga-meditation': yogaMeditationConfig,
};

// Export categories array for compatibility - Updated for curated samples
export const categories = Object.keys(categoryConfigs).map(id => ({
  id,
  ...categoryConfigs[id]
}));